module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "verdict",
    class: {
      'mobile': _vm.$mobile
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro-text-container"
  }, [_c('div', {
    staticClass: "intro-text-box"
  }, [_c('div', {
    staticClass: "introtext title-02"
  }, [_vm._v("\n                De rechter volgde de eis van de officier van justitie en legde de man 8 jaar gevangenisstraf op en tbs met dwangverpleging. In hoger beroep werd de man veroordeeld tot 6 jaar gevangenisstraf met tbs.\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    class: {
      'mobile': _vm.$mobile
    },
    attrs: {
      "to": "/gefeliciteerd"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('br'), _c('br')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('img', {
    staticClass: "image-intro",
    attrs: {
      "src": "/images/289.jpg",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7032d638!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/verdictScreen.vue
// module id = 121
// module chunks = 1